import { FunctionComponent } from 'react';
import ReactHtmlParser from 'react-html-parser';

import { Props } from './index';
import StyledComponent from './styles';

const LayoutHtmlStyledContent: FunctionComponent<Props> = ({ html, className }) => {
    return (
        <StyledComponent className={className}>
            {ReactHtmlParser(html)}
        </StyledComponent>
    );
};

export default LayoutHtmlStyledContent;